import { render, staticRenderFns } from "./TabOplevering.vue?vue&type=template&id=2e73c490"
import script from "./TabOplevering.vue?vue&type=script&lang=js"
export * from "./TabOplevering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports